import type { FUSportsMatchWithNativeId } from "@/utilities/data/types";
import type { AdaptedTeamEvent } from "@/utilities/data/team/types";

/**
 * Project AdaptedTeamEvent[] into the FUSportsMatchWithNativeId[] shape that
 * the data-layer SDK helpers (useTeamFormData, getTeamResultsTable, etc.)
 * expect. Carries enough competitor identity (name, assets, branding, country)
 * for form rendering; the SDK ignores fields it doesn't read.
 */
export function toSDKMatches(events: AdaptedTeamEvent[]): FUSportsMatchWithNativeId[] {
    return events.map((e) => ({
        id: e.id,
        fansUnitedMatchId: e.fansUnitedMatchId,
        status: e.status,
        timing: { kickoffTime: e.date },
        score: {
            competitorOne: e.score.fullTime.competitorOne,
            competitorTwo: e.score.fullTime.competitorTwo,
        },
        competitorOne: {
            id: e.competitorOne.id,
            name: e.competitorOne.name,
            shortName: e.competitorOne.shortName,
            type: e.competitorOne.type,
            assets: e.competitorOne.assets,
            metadata: e.competitorOne.metadata,
            country: e.competitorOne.country,
        },
        competitorTwo: {
            id: e.competitorTwo.id,
            name: e.competitorTwo.name,
            shortName: e.competitorTwo.shortName,
            type: e.competitorTwo.type,
            assets: e.competitorTwo.assets,
            metadata: e.competitorTwo.metadata,
            country: e.competitorTwo.country,
        },
        competition: e.competition,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    })) as unknown as FUSportsMatchWithNativeId[];
}
